/**
 * <ReferralShareHeader> — referral modal hero strip (molecule, L0.1).
 *
 * Hero card with title, reward subtitle, and Zoé mascot.
 *
 * Elle est peinte en `brand-fill` — l'aplat de marque — et non en `primary`, qui s'inverse sur la
 * nuit : juste pour un poussoir de 44 px, faux pour un bandeau de 100 px, qui devenait le seul
 * rectangle blanc de tout l'espace parent en sombre. L'encre se lit dans le descripteur d'aplat,
 * pour que la paire mesurée par le test de contraste soit exactement celle qui est peinte.
 */
import { StyleSheet } from "react-native-unistyles"

import { Mascot } from "../../atoms/Mascot"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Title } from "../../atoms/typography/Title"
import { inkOnFill, type SemanticColorKey } from "../../theme/tokens/colors"
import { Card } from "../Card"

const FILL: SemanticColorKey = "brand-fill"
const INK = inkOnFill(FILL)

export type ReferralShareHeaderProps = {
    /** e.g. "50\u00a0€" — falls back to "des récompenses". */
    rewardLabel?: string
    testID?: string
}

export function ReferralShareHeader(props: ReferralShareHeaderProps) {
    const { rewardLabel, testID } = props

    return (
        <Card background={FILL} p="4" style={styles.header} testID={testID}>
            <Row justify="between" align="center">
                <Stack gap="1" style={styles.headerText}>
                    <Title size="text-xl" color={INK}>
                        Partagez Masteur
                    </Title>
                    <Text size="text-sm" color={INK} style={styles.subtitle}>
                        et gagnez {rewardLabel ?? "des récompenses"}
                    </Text>
                </Stack>
                <Mascot name="zoe" variant="happy" size={70} />
            </Row>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    header: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    headerText: {
        flex: 1,
        flexShrink: 1,
    },
    subtitle: {
        opacity: 0.9,
    },
}))
